<template>
  <div
    class="modal fade"
    id="modalObservacionB"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header header-observacion">
          <h5 class="modal-title titulo-observacion">
            {{ tipoPersonaRecuperada != 2 && tipoPersonaRecuperada != 5 && tipoPersonaRecuperada != 7 ? "Observación" : "Observation" }} 
            </h5>
        </div>
        <div class="modal-body">
          <p class="text-center texto-observacion" v-if="Observacion != null">
            {{ Observacion.toLowerCase() }}
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn boton-primario"
            data-bs-dismiss="modal"
          >
           {{ tipoPersonaRecuperada != 2 && tipoPersonaRecuperada != 5 && tipoPersonaRecuperada != 7 ? "Cerrar" : "Close" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--TERMINAL MODAL-->
</template>

<script>
export default {
  props: {
    Observacion: String,
    tipoPersona: Number
  },
  data() {
    return {
      tipoPersonaRecuperada: null
    };
  },
   async mounted() {
     this.tipoPersonaRecuperada = this.$store.getters.tipoPersona;
    }
};
</script>

<style lang="scss" scoped>
$color-primario: #b8725a;
$negro-embajadores: #1e2120;
$poppins: "Poppins";

/*Modal observación*/
.modal-header {
  border-bottom: none;
  display: flex;
  justify-content: center;
  padding-bottom: -5px;
}
.modal-footer {
  border-top: none;
  justify-content: center;
  padding-top: -5px;
}
.modal-footer button {
  width: 40%;
}
.modal-dialog {
  max-width: 50%;
}
.modal-content {
  border-radius: 0px;
  border: 1px solid #707070 !important;
}
.header-observacion {
  text-align: center;
}
.texto-observacion {
  font-family: $poppins;
  color: $negro-embajadores;
  text-align: justify;
}
.titulo-observacion {
  font-family: $poppins;
  text-align: center;
  color: #000000;
  font-weight: 700;
}
.boton-primario {
  border-radius: 0px;
  background-color: $color-primario;
  box-shadow: none;
  color: #ffffff;
  font-family: $poppins;
  height: 50px;
}

@media all and (max-width: 767px) {
  .modal-dialog {
    max-width: 80%;
    margin-left: 10%;
  }
  .titulo-observacion {
    font-size: 17px;
  }
  .texto-observacion {
    font-size: 14px;
  }
}
</style>
